/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import ReactSelect, { components } from 'react-select';

import InputWrapper from '../inputWrapper/index';

const Option = props => {
  const { label, icon: Icon } = props.data;
  const [hover, setHover] = useState(false);

  const showHoverColor = hover && !props.isSelected;

  return (
    <components.Option {...props}>
      <div
        style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
        className="select-option"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={() => setHover(false)}
      >
        {Icon && window.innerWidth > 390 &&
          <Icon
            fill={showHoverColor ? "#895d85" : 'currentColor'}
            size="30"
          />
        }
        <span style={{ color: showHoverColor ? '#895d85' : 'currentColor', fontSize: '.95rem' }}>
          {label}
        </span>
      </div>
    </components.Option>
  );
};

const SingleValue = props => {
  const { label, icon: Icon } = props.data;

  return (
    <components.SingleValue {...props}>
      <div className="select-option" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        {Icon && window.innerWidth > 390 &&
          <Icon fill="currentColor" size="30" />
        }
        <span>{label}</span>
      </div>
    </components.SingleValue>
  );
};

export default function SelectInput({ value, setValue, options, title, note, placeholder, optional = false, error }) {
  return (
    <div className="select-input">
      <InputWrapper title={title} note={note} optional={optional} error={error}>
        <ReactSelect
          isSearchable
          theme={theme => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary:   '#895d85',  // selected bg + focus ring
              primary75: '#A87BA4',  // active/pressed state
              primary50: '#D4B8D2',  // lighter active state
              primary25: '#EDE3EC',  // hover bg on options
            },
          })}

          menuPortalTarget={document.body}
          options={options}
          value={options?.find(o => o.value === value) || null}
          onChange={opt => setValue(opt?.value)}
          placeholder={placeholder}
          className="select"
          classNamePrefix="select"
          components={{ Option, SingleValue }}
        />
      </InputWrapper>
    </div>
  );
}